export default __webpack_public_path__ + "static/media/partner-spotless.cd124941.png";